import { SkillsContract } from '@terra/shared-contracts-ai-skills';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const aiSkillsClient = createTerraOrpcClient({
  contract: SkillsContract,
  serviceName: SERVICE_NAME,
});
